export default {
    data() {
        return {
        }
    },
    methods: {
        getServiceCode(item) {
            return item?.service?.code ?? '';
        },
        getClassServiceCode(item) {
            let cl = null;
            let code = this.getServiceCode(item);
            switch(code.toLowerCase()) {
                case 'wms':
                    cl = 'badge-info';
                    break;
                case 'wfs':
                    cl = 'badge-warning';
                    break;
                case 'wmts':
                    cl = 'badge-secondary';
                    break;
                default:
                    cl = 'badge-dark';
            }
            return cl;
        },
        getColorServiceCode(service) {
            let cl = null;
            let code = service?.service?.code ?? '';
            switch(code.toLowerCase()) {
                case 'wms':
                    cl = 'text-info';
                    break;
                case 'wfs':
                    cl = 'text-warning';
                    break;
                case 'wmts':
                    cl = 'text-secondary';
                    break;
                default:
                    cl = 'text-dark';
            }
            return cl;
        },
    },
};